import { GridRowsImage } from './GridRowsImage';

export const NoRowsOverlay = () => {
  return <GridRowsImage label="No Rows" />;
};
